import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import ButtonWithLoading from 'src/components/common/ButtonWithLoading';
import ImageComponent from 'src/components/common/Image';
import ModalComponent from 'src/components/Modal/ModalComponent';

// Utilities
import { ICON_UPGRADE_PLAN } from 'src/utils/constants/imagesUrl';
import { AuthRouteKeys } from 'src/utils/constants/routes';
import { useFeatureRestrictionStore } from 'src/zustand/useFeatureRestrictionStore';

const FeatureRestriction: React.FC = () => {
  const navigate = useNavigate();
  const { visible, handleClose } = useFeatureRestrictionStore((state) => state);

  const navigatePricingPage = () => {
    navigate(AuthRouteKeys.Pricing);
    handleClose();
  };

  return (
    <ModalComponent
      closeOnBackdropClick={false}
      padding={4}
      open={visible}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'rgba(45, 45, 45, 0.72)',
            backdropFilter: 'blur(4px)',
            WebkitBackdropFilter: 'blur(4px)',
          },
        },
      }}
      handleClose={handleClose}
      showCloseIcon={true}
    >
      <Stack direction="column" spacing={2} width={504} alignItems="center">
        <ImageComponent imgSrc={ICON_UPGRADE_PLAN} height={150} />

        <Stack spacing={1} alignItems="center">
          <Typography textAlign="center" variant="h4" fontWeight="bold">
            Feature Restriction
          </Typography>
          <Typography textAlign="center" variant="subtitle1" color="text.secondary">
            Upgrade Your Current Plan
          </Typography>
        </Stack>

        <Typography textAlign="center" variant="body1">
          Your current plan doesn't include this feature/function. To continue exploring and unlocking valuable data,{' '}
          <Typography onClick={navigatePricingPage} component="span" color="secondary.main" sx={{ cursor: 'pointer' }}>
            please visit the All Plans page
          </Typography>{' '}
          and choose a suitable plan.
        </Typography>

        <ButtonWithLoading variant="contained" color="primary" size="large" onClick={handleClose} fullWidth isRounded>
          Close
        </ButtonWithLoading>
      </Stack>
    </ModalComponent>
  );
};

export default FeatureRestriction;
